
import { utcToZonedTime, format } from 'date-fns-tz';
let timeZone = 'Asia/Jerusalem';

export default function(date){
	if(!date) return '';
	const zoned = utcToZonedTime(date,timeZone);
	return format(zoned, 'yyyy-MM-dd HH:mm', {timeZone});//weird that we need time zone references in both lines
	}

export function display_date_seconds(date){
	if(!date) return '';
	const zoned = utcToZonedTime(date,timeZone);
	return format(zoned, 'yyyy-MM-dd HH:mm.ss', {timeZone});//weird that we need time zone references in both lines
	}